module.exports = __webpack_public_path__ + "img/logo-aft.3819f7b.png";